import safeCreateAction from "../../../actions/safeCreateAction";
import Bluebird from "bluebird";
import { batchDispatch } from "../../../util/util";
/**
 * add or edit a profile
 */
export const setProfile = safeCreateAction("SET_PROFILE", (profile) => profile);
export const removeProfile = safeCreateAction("REMOVE_PROFILE", (profileId) => profileId);
export const willRemoveProfile = safeCreateAction("WILL_REMOVE_PROFILE", (profileId) => profileId);
/**
 * enable or disable a mod in a profile
 */
export const setModEnabled = safeCreateAction("SET_MOD_ENABLED", (profileId, modId, enable) => ({
    profileId,
    modId,
    enable,
}));
export const forgetMod = safeCreateAction("FORGET_PROFILE_MOD", (profileId, modId) => ({ profileId, modId }));
export const setFeature = safeCreateAction("SET_PROFILE_FEATURE", (profileId, featureId, value) => ({
    profileId,
    featureId,
    value,
}));
export const setProfileActivated = safeCreateAction("SET_PROFILE_ACTIVATED", (active) => active);
const setModsEnabled = (() => {
    let ppFunc;
    return (api, profileIdIn, modIdsIn, enableIn, optionsIn) => {
        const { profileById } = require("../selectors");
        if (ppFunc === undefined) {
            ppFunc = api.withPrePost("enable-mods", (profileId, modIds, enable, options) => {
                if (modIds.length > 0) {
                    const profile = profileById(api.getState(), profileId);
                    if (profile !== undefined) {
                        batchDispatch(api.store, modIds.map((id) => setModEnabled(profileId, id, enable)));
                        api.events.emit("mods-enabled", modIds, enable, profile.gameId, options);
                    }
                }
                return Bluebird.resolve();
            });
        }
        {
            const profile = profileById(api.getState(), profileIdIn);
            if (profile === undefined) {
                return Bluebird.resolve();
            }
            const willChange = modIdsIn.filter((id) => (profile.modState?.[id]?.enabled ?? false) !== enableIn);
            return ppFunc(profileIdIn, willChange, enableIn, optionsIn).catch((err) => {
                api.showErrorNotification("Failed to enable/disable mod", err);
            });
        }
    };
})();
export { setModsEnabled };
